import React, { Component } from 'react';
import propTypes from 'prop-types';
import { Link } from 'gatsby';
import styles from './country-panel.css';

class CountryList extends Component {
  static propTypes = {
    continents: propTypes.array.isRequired
  };

  render() {
    const { continents } = this.props;

    return (
      <div className={styles.countryList}>
        {continents.map((continent, index) => {
          return (
            <div key={index}>
              <h4>{continent.continent}</h4>
              <ul>
                {continent.countries.map(country => (
                  <li key={country}>
                    <Link to={`/${country.toLowerCase().replace(' ', '_')}`}>{country}</Link>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    );
  }
}

export default CountryList;
